import { OpenAPI } from '@acme/api';
import '@acme/domains/styles';
import '@acme/features/styles';
import '@acme/foundation/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

OpenAPI.BASE = import.meta.env.VITE_API_BASE;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
